export function sanitizeTokenName(tokenInput) {
  if (typeof tokenInput !== "string") return "__IGNORE__";

  const token = tokenInput.trim().toUpperCase();

  // ✅ Spezielle Token mit expliziter Behandlung
  if (token === "B3TR") return "B3TR";
  if (token === "VEB3TR") return "VEB3TR";
  if (token === "VTHO") return "VTHO";
  if (token === "VET") return "VET";
  
  // ✅ Alle anderen Token werden unterstützt (nicht mehr __IGNORE__)
  if (token.length > 0) return token;
  
  // Nur leere Strings werden ignoriert
  return "__IGNORE__";
}